import { defineComponent } from "vue";
import useNavigation from "@/composables/navigation";
export default defineComponent({
    name: "Navigation",
    setup() {
        const { isMenuOpen } = useNavigation();
        return {
            isMenuOpen,
        };
    },
});
